import { atom } from 'recoil';

export interface SingleLegend {
    legendLabels: {
        legendStart: number,
        legendEnd: number,
        legendLabel: string
    }[],
    legendStartColor: string,
    legendEndColor: string,
    hasData: {
        CTV: boolean,
        EH: boolean,
        PoI: boolean
    }
}

export type LegendGeoLevel = 'hex' |'village' |'sub_district' | 'pincode' | 'district' | 'state';

export type LegendProperties = Partial<Record<LegendGeoLevel, SingleLegend>>;

export interface poiColorProps {
    geoId: number,
    color: string,
}

export interface topRegionsProps {
    country: number,
    state: number,
    district: number,
    geoname: string,
    value: number,
    geotype: string
}

export interface rootProps {
    geoId: number | string;
    geoName: string;
    geoType: string;
    geoLevelNumber: number;
    region: string;
    show: boolean;
    type: string;
    filters: any[];
    filterProperties: { isAdjusted: boolean };
    metricProperties: { hasData: boolean };
    metric_type: { key: string, ismetric: boolean }[]
    prevGeoId: number;
    cat: { category: number[], subcategory: number[] };
}

export interface geoJSONProps {
    type: string;
    features: any;
    rootProperties: rootProps;
}

export interface mapColorProps {
    colorProperties: poiColorProps[];
    legendProperties: LegendProperties
    rootProperties: rootProps;
    topRegions: topRegionsProps
}

const geoJsonState = atom({
    key: 'geojson',
    default: {} as geoJSONProps
});

const poiMapColorState = atom({
    key: 'poiMapColor',
    default: {} as mapColorProps
});

const ptypeState = atom<string>({
    key: 'ptypeState',
    default: 'Branch'
});

export { geoJsonState, poiMapColorState, ptypeState };